import type { ReactNode } from "react";

import { LockIcon } from "@phosphor-icons/react";

import { classNames } from "@alpacahq/ui/old";

import { SealCheckIcon } from "~/v2/components/common";

export interface PlanBoxProps {
  isHighlighted?: boolean;
  isDisabled?: boolean;
  icon: ReactNode;
  title: string;
  price: ReactNode;
  badge?: ReactNode;
  items: {
    text: string;
    isChecked?: boolean;
  }[];
  button: string;
  onClick?: () => void;
}

export const PlanBox = ({
  isHighlighted,
  isDisabled,
  icon,
  title,
  price,
  badge,
  items,
  button,
  onClick,
}: PlanBoxProps) => (
  <button
    type="button"
    onClick={onClick}
    className={classNames(
      "flex h-full w-full flex-col justify-between gap-4 rounded border p-4 disabled:cursor-not-allowed",
      isHighlighted
        ? "border-yellow-600 bg-[linear-gradient(106deg,_rgba(255,252,216,0.65)_-38.69%,_#FFF_97.09%)]"
        : "border-gray-200 bg-white",
    )}
    disabled={isDisabled}
  >
    <div className="flex flex-col justify-start gap-4">
      <div className="flex flex-col gap-3">
        <div className="flex items-center justify-between gap-2">
          <div className="flex items-center gap-2">
            {icon}
            <h2 className="m-0 p-0 text-left font-semibold text-gray-800 text-lg leading-[26px]">
              {title}
            </h2>
          </div>
          {price}
        </div>
        <div className="flex min-h-[26px] justify-start">{badge}</div>
      </div>
      <ul className="m-0 flex flex-col gap-4">
        {items.map(({ text, isChecked }) => (
          <li className="flex items-center gap-2" key={text}>
            {isChecked ? (
              <SealCheckIcon />
            ) : (
              <LockIcon className="text-gray-500" size={20} />
            )}
            <p
              className={classNames(
                "m-0 p-0 text-base text-gray-700",
                !isChecked && "text-gray-500 line-through",
              )}
            >
              {text}
            </p>
          </li>
        ))}
      </ul>
    </div>
    <p
      className={classNames(
        "m-0 flex w-full items-center justify-center rounded px-4 py-2 font-medium text-sm",
        isDisabled && "bg-gray-100 text-gray-500",
        isHighlighted && "bg-yellow-300 text-gray-800",
      )}
    >
      <span>{button}</span>
    </p>
  </button>
);
